<template>
  <div id="app" v-loading.fullscreen="!initialized">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app",

  created() {
    this.$store.dispatch("auth/init");
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.$store.dispatch("shared/resize", {
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
  },

  computed: {
    ...mapGetters({
      initialized: "auth/initialized"
    })
  }
};
</script>

<style scoped>
#app > .version-app {
  position: absolute;
  color: #909399;
  left: 10px;
  bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/app.vue?d415c9b6